import React, { useState, useMemo } from 'react';
import FullWithModal from '../common/Modal/FullWidthModal';
import ReceiptScreen from '../ReceiptScreenNewUI/index';
import { getObjectValue } from '@utility/utills';
import { flowType } from '@utility/userInfo';
import { LABEL } from '../../veriables';
import { APP_CONFIG } from '@constants';
import LockIcon from '@assets/images/lockIcon.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import PaymentImg from '@assets/images/Payment152.png';
import cn from 'classnames';
import style from './index.module.scss';

const PaymentTerminal = (props) => {  
  const showStoreLogo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')), false);
  const auth = JSON.parse(window.sessionStorage.getItem('auth'))

  // State Management
  const [countryCode, setCountryCode] = useState(auth.countryCode? auth.countryCode: '1');
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const isServerApp = flowType() === 'serverApp';

  // Methods

  const isWalkUp = getObjectValue(
    () => props?.check && props?.check?.sourceType === 7,
    false
  );
  const isDefaultMode = getObjectValue(
    () =>
      !isWalkUp &&
      (!props.deviceInfo.deviceGroup ||
        [0].includes(props.deviceInfo.deviceGroup.startMode)),
    false
  );
  const lockPaymentScreen = getObjectValue(
    () =>
      ((isServerApp && isDefaultMode)) &&
      props.auth.serverAppFeatures.lockPaymentScreen,
    false
  );

  const renderModifier = (modifiersObj, node) => (
    <div className={cn('pl-2')}>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.modifiers[0].quantity > 1 && (<span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.modifiers[0].quantity} &times;</span>)}
              { (props.isLandScape) ? <span style={{color : 'rgb(168, 197, 251)'}}>{modifier.modifierName}</span> : <> {modifier.modifierName} </>}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
              {modifier.price ? (<small className="ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            </div>
          );
        }
        return (
          <div key={modifier.id} className="fs-14 fw-500">
            {modifier.quantity > 1 && <span className={cn('badge badge-warning ml-1 va-tt', node === 0 ? 'float-right' : '')}>{modifier.quantity} &times;</span>}
            { (props.isLandScape) ? <span style={{color : 'rgb(168, 197, 251)'}}>{modifier.modifierName}</span> : <> {modifier.modifierName} </>}
            {modifier.price ? (<small className="ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers)
            )}
          </div>
        );
      })}
    </div>
  );

  const renderModifierView = (modifiersObj, node, nest) => (
    <div>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="col-12 p-0 d-flex fw-500" style={{fontSize:props.isLandScape?'10px' :'12px'}}>
              {modifier.modifiers[0].quantity >= 1 ? (<div className='p-0 text-center col-2 pl-1'><div className={cn('va-tt', (props.isLandScape && !props.viewDetails && modifier.modifiers[0].quantity !== 1 ) && 'badge badge-warning',  node === 0 ? 'float-right' : '') } style = {{marginLeft : modifier.modifiers[0].quantity == 1 && '0.1rem', color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>{ (props.isLandScape && !props.viewDetails && modifier.modifiers[0].quantity == 1) ? '' : modifier.modifiers[0].quantity}  </div></div>) : <div className='p-0 text-center col-2 px-1'> </div> }
              <div className='col-4 p-0 text-left' style={{color: (nest||props.viewDetails) ? props?.serverAppTheme?.primary_text :  '#5081DE'}}> {modifier.modifierName}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt" style={{color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>&times; {modifier.quantity}</span>)}
              </div> 
              <div className='px-0 h-8 d-flex align-items-center col-2'></div>
              {modifier.price ? (<div className="col-4 text-right p-0" style={{color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</div>) : ''}
            </div>
          );
        }
        return ( <>
          <div key={modifier.id} className="col-12 p-0 fw-500 d-flex" style={{fontSize:props.isLandScape?'10px' :'12px'}}>
            {modifier.quantity >= 1 ? <div className={cn('col-1 text-center p-0', props.isLandScape ? 'col-2 pl-2 px-1' :'col-1')}> <div className={cn('va-tt')} style={{color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>{modifier.quantity}</div></div> : <div className='p-0 text-left col-2 px-1'></div>}
            <div className={cn(' p-0 text-left', props.isLandScape, props.isLandScape ? 'col-4' :'col-7')}> {nest && <span className='fs-20 pt-1' style={{color:props?.serverAppTheme?.modifier_arrowDown}}>⮡</span>} <span className={cn(nest && 'pl-2')} style={{color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>{modifier.modifierName}</span></div>
            <div className={cn('px-0 h-8 d-flex align-items-center col-1', props.isLandScape ? 'col-3' :'col-1')}></div>
            {modifier.price ? (<div className={cn("col-3 text-right p-0")} style={{color: (nest || props.viewDetails) ? props?.serverAppTheme?.primary_text : '#5081DE'}}>{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</div>) : ''}
            {(modifier.note || modifier.comment) && <div className={cn("pl-2", style.modifierNoteAndComment)} style={{'--note-color': serverAppTheme?.notes}}>{modifier.note || modifier.comment}</div>}
          </div>
          <div>
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifierView(modifier.modifiers, node ,true)
            )}
          </div>
          </>
        );
      })}
    </div>
  );

  const inLineStyle = useMemo(() => {
      const viewDetailsPopup =  {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        pointerEvents: 'auto',
        backgroundColor: props?.serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        height: '100%',
        borderRadius: "16px",
        border: props?.serverAppTheme?.popupBorder,
        boxShadow: props?.serverAppTheme?.popUp_box_shadow
    }
    return {viewDetailsPopup}
  },[props?.serverAppTheme, props?.isLandScape])
  // HTML CSS CODE
  
  return (
    <div className="h-100 position-relative">
   {!props.isLandScape && <>   <div style={{right:0, top:0, width:'7%', height:'4%', zIndex:'1'}} className='col-1 px-0 rounded position-absolute'>
        <div 
          className='w-100 h-100 d-flex justify-content-center align-items-center' 
          style={{background : props?.serverAppTheme?.iconcolor_bg_box, borderRadius: '4px' }} 
          tabIndex="0" 
          role="button"
          onClick={() => props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`)}
        >
            {lockPaymentScreen ? <img src={LockIcon} alt='lock' width={'70%'}/> : <Cross fill = {props.serverAppTheme?.primary_text} alt='cross' width={'70%'}/>}

        </div>
      </div>  
      <div style={{height:'4%'}} className='col-12 px-0 fs-26 text-white text-center'>
        {LABEL().TABLE} {(props?.check?.stationName?.length > 8 ? props?.check?.stationName.substring(0,9) + '...' : props?.check?.stationName) ||(props?.check?.name?.length > 8 ? props?.check?.name.substring(0,9) + '...' : props?.check?.name) || props?.check?.stationNumber}
      </div>
       <div style={{marginTop:'2%'}} className='col-12 px-0 h-18'>
         {showStoreLogo?.imageUrl ? 
           <div className='h-100 w-100 '>
            {<img src={showStoreLogo?.imageUrl} style={{top:'50%', left:'50%',transform:'translate(-50%, -50%)', minWidth:'100%', minHeight:'100%'}} className="img-fluid mx-auto d-block h-100 w-100 position-absolute" alt=" " />}
           </div>
          : 
            <div className='h-100 w-100'>
               <img src={PaymentImg} alt='paymentImg'/> 
            </div>
          }
      </div> </>}
     { props.viewDetails &&
       <FullWithModal
       isOpen={props.viewDetails}
       isModalCenter
       customClass2={cn("w-100 h-100 p-3")}
       noBackground
      style = {inLineStyle?.viewDetailsPopup}
     >
       <div className='col-12 p-2 justify-content-center align-items-center position-relative text-center w-100 h-100 text-white'>
           <div className={cn("col-12 d-flex p-0 text-right", style.viewDetailsPopup)} role="presentation"  onClick={props.viewDetailsOnClose}>
               <div style={{height:'4%', color: props?.serverAppTheme?.primary_text}} className='col px-0 fs-26 text-center'>
                   {LABEL().TABLE} {(props?.check?.stationName?.length > 8 ? props?.check?.stationName.substring(0,9) + '...' : props?.check?.stationName) ||(props?.check?.name?.length > 8 ? props?.check?.name.substring(0,9) + '...' : props?.check?.name) || props?.check?.stationNumber}
               </div>
               <Cross fill={props.serverAppTheme?.iconcolor} />

           </div>
           <div className='col-12 px-5  h-90'>
             <ReceiptScreen renderModifierView = {renderModifierView} viewDetails = {!props.isLandScape  && !props?.viewDetails} viewDetailsOnClose = {props.viewDetailsOnClose} viewDetailsPopup = {props.viewDetailsPopup} currenySymbol={LABEL().CURRENCY_SYMBOL} countryCode={countryCode} paymentType={1} supportsTips tableData={props?.isLandScape ? props?.checkListLength > 0 ? props?.check : [] : props?.check} checkListLength = {props.checkListLength} tipAmount={props?.check?.tipAmount} renderModifier={renderModifier} allMenuItems={props?.allMenus} isPaymentTerminal={isPaymentTerminal} seat={props?.check} isLandScape = {props.isLandScape}  serverAppTheme={props?.serverAppTheme}/>
            </div>
     </div>

     </FullWithModal>
     }

      {!props.viewDetails && <div className={cn(!props.isLandScape ? 'h-68 py-2 position-relative' : 'ml-1 h-90')}>
        <ReceiptScreen renderModifierView = {renderModifierView} checksLength = {props.checksLength} viewDetailsPopup = {props.viewDetailsPopup} currenySymbol={LABEL().CURRENCY_SYMBOL} countryCode={countryCode} paymentType={1} supportsTips tableData={props?.check} checkListLength = {props.checkListLength} tipAmount={props?.check?.tipAmount} renderModifier={renderModifier} allMenuItems={props?.allMenus} isPaymentTerminal={isPaymentTerminal} seat={props?.check} isLandScape = {props.isLandScape} viewDetails = {true}  serverAppTheme={props?.serverAppTheme} />
      </div>}
    {props.isLandScape ? props?.checkListLength > 0 && props?.check?.items && props?.check?.items?.length > 0 && ( <div style={{bottom: !props.isLandScape && 0}} className="col-12 px-1 d-flex align-items-center h-10">
        <div className={cn("col-6 pl-0 pr-0")}>
          <button disabled={props?.check?.totalAmount - props?.check?.paidAmount === 0 || (props?.check?.tickets?.filter((e) => (e.ticketStatusId === 0 || e.ticketStatusId === 1) && (e.ticketSplitTypeId === 2 || e.ticketSplitTypeId === 3)).length > 0)} className={cn("btn btn-secondary od-btn-secondary w-100", style.StageButton)} type="button" onClick={() => { props.toToStage(); }} style={{height:'8.5vh', backgroundColor:props?.serverAppTheme?.OFF_Premise_Btn, border:'1px solid #0060FF', color: props?.serverAppTheme?.primary_text }}>
            <div className={cn('fs-32 fw-600')}>{LABEL().STAGE}</div>
          </button>
        </div>
        <div className={cn("col-6 pr-0 pl-1")}>
        <button disabled={(props?.check?.items?.length && props?.check?.subTotalAmount === props?.check?.discountAmount ? false : Number(props?.check?.unpaidAmount) === 0) ||  props?.check?.paymentStages.some((item) =>  item.status === 0)} className={cn("btn btn-primary btn-ripple od-btn-primary border-0", style.payButton)} type="button" onClick={() => { props.navigateToPaymentScreen(); }} style={{height:'8.5vh', backgroundColor:'#0060FF' }}>
            <div className={cn('fs-32 fw-600')}>{LABEL().PAY}</div>
          </button>
        </div>
      </div>) : (<div style={{bottom: !props.isLandScape && 0}} className="col-12 px-0 d-flex h-8 align-items-center position-absolute">
        <div className="col-6 pl-0 pr-1">
          <button disabled={props?.check?.totalAmount - props?.check?.paidAmount === 0 || (props.check?.tickets?.filter((e) => (e.ticketStatusId === 0 || e.ticketStatusId === 1) && (e.ticketSplitTypeId === 2 || e.ticketSplitTypeId === 3)).length > 0)} className="btn btn-secondary od-btn-secondary w-100" type="button" onClick={() => { props.toToStage(); }} style={{height:'7.5vh', backgroundColor:props?.serverAppTheme?.OFF_Premise_Btn, border:'1px solid #0060FF', color: props?.serverAppTheme?.primary_text }}>
            <div className={cn('fs_28 fw-600')}>{LABEL().STAGE}</div>
          </button>
        </div>
        <div className="col-6 pr-0 pl-1">
        <button disabled={(props?.check?.items?.length && props?.check?.subTotalAmount === props?.check?.discountAmount ? false : Number(props?.check?.unpaidAmount) === 0) ||  props?.check?.paymentStages.some((item) =>  item.status === 0)} className="btn btn-primary btn-ripple od-btn-primary w-100" type="button" onClick={() => { props.navigateToPaymentScreen(); }} style={{height:'7.5vh', backgroundColor:'#0060FF' }}>
            <div className={cn('fs_28 fw-600')}>{LABEL().PAY}</div>
          </button>
        </div>
      </div>)}
    </div> 
  );
};

export default PaymentTerminal;
